import React from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Link,
} from "@material-ui/core";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import Progress from "./progress";

export default function SearchResults({
  totalCount,
  charities,
  searching,
  onGetMore,
}) {
  const useStyles = makeStyles((theme) => ({
    main: {
      margin: "0px",
    },
    results: {
      margin: "0px",
    },
    image: {
      width: "100%",
    },
    link: {
      display: "flex",
    },
    button: {
      "&:hover": { background: "none", boxShadow: "none" },
      "&:active": { background: "none", boxShadow: "none" },
    },
  }));
  const classes = useStyles();

  return (
    <Grid item container xs={12} spacing={2} className={classes.main}>
      <Grid item xs={12}>
        <Typography variant="subtitle1">
          {totalCount == 0 && "No results"}
          {totalCount > 1 &&
            totalCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              " results"}
          {totalCount == 1 && "1 result"}
        </Typography>
      </Grid>
      <Grid item container xs={12} spacing={2} className={classes.results}>
        {charities.map((charity) => {
          return (
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              key={charity.ein}
              itemScope
              itemType="https://schema.org/Organization"
            >
              <Link
                href={`/charity/${encodeURI(charity.name)}/?ein=${charity.ein}`}
                itemProp="url"
              >
                <Card>
                  <CardActionArea className={classes.button}>
                    <CardMedia
                      itemProp="image"
                      component="img"
                      alt={charity.name + " Charity"}
                      image={charity.image}
                      title={charity.name}
                    />
                    <CardContent>
                      <Typography variant="h6" itemProp="name">
                        {charity.name}
                      </Typography>
                      <Typography variant="subtitle2">{charity.ein}</Typography>
                      <Typography variant="subtitle2">
                        <div
                          itemProp="address"
                          itemScope
                          itemType="https://schema.org/PostalAddress"
                        >
                          <div itemProp="streetAddress">{charity.street}</div>
                          <div>
                            <span itemProp="addressLocality">
                              {charity.city}
                            </span>
                            ,&nbsp;
                            <span itemProp="addressRegion">
                              {charity.state}
                            </span>
                            &nbsp;
                            <span itemProp="postalCode">
                              {charity.postalCode}
                            </span>
                          </div>
                        </div>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
          );
        })}
        <Grid item xs={12}>
          <Progress busy={searching} />
        </Grid>
        <BottomScrollListener
          onBottom={() => {
            onGetMore();
          }}
        />
      </Grid>
    </Grid>
  );
}
